import { createSlice } from '@reduxjs/toolkit';

/**
 * Staff-only Demo admin state. Backed by /v5/demo, gated server-side by the Firestore staff-email
 * allowlist (developerCheck) — this slice's presence in the store grants nothing on its own.
 *
 * ⚠️ `restoring` is keyed BY ORG, not a single boolean. Two demo workspaces exist, and a shared flag
 * would grey out both buttons while one restores — making it look as though the other had failed.
 */
const initialState = {
	workspaces: [],
	slugs: [],
	jobs: [],
	loading: false,
	loaded: false,
	error: null,
	restoring: {},
	activeJob: null
};

const demoSlice = createSlice({
	name: 'demo',
	initialState,
	reducers: {
		loadDemoStatus: (state) => {
			state.loading = true;
			state.error = null;
		},
		loadDemoStatusSuccess: (state, action) => {
			state.loading = false;
			state.loaded = true;
			state.workspaces = action.payload?.workspaces ?? [];
			state.slugs = action.payload?.slugs ?? [];
			state.jobs = action.payload?.jobs ?? [];
			state.error = null;
		},
		loadDemoStatusError: (state, action) => {
			state.loading = false;
			state.error = action.payload;
		},

		restoreDemoOrg: (state, action) => {
			state.restoring[action.payload.orgID] = true;
			state.error = null;
		},
		/* The POST returns 202 + a job; the work is still running when this fires. */
		restoreDemoOrgAccepted: (state, action) => {
			state.activeJob = action.payload;
		},
		/*
		 * Terminal for one org. `restoring` is cleared here and ONLY here, so a failed restore
		 * re-enables its button — a destructive action that leaves its own control disabled after
		 * failing reads as "still running" and invites a second click nobody intended.
		 */
		restoreDemoOrgSettled: (state, action) => {
			const { orgID, job, error } = action.payload ?? {};
			delete state.restoring[orgID];
			if (job) state.activeJob = job;
			if (error) state.error = error;
		},
		pollRestoreJob: () => {},
		clearDemoError: (state) => {
			state.error = null;
		}
	}
});

export const demoActions = demoSlice.actions;
export default demoSlice.reducer;
